module.exports = __webpack_public_path__ + "img/28.840054a5.png";